import React, { useState, useEffect } from 'react';
import './style.css';
import ClockHands from './clock.js';
import mapping from './mapping.json';

export default function App() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timerId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timerId);
  }, []);
  let hours = currentTime.getHours();
  let hourDigitis = ('0' + hours).toString().slice(-2).split('');
  let minutes = currentTime.getMinutes();
  let minDigits = ('0' + minutes).toString().slice(-2).split('');
  let seconds = currentTime.getSeconds();
  let secondDigits = ('0' + seconds).toString().slice(-2).split('');
  return (
    <div className="flex">
      <div className="flex-body">
        {hourDigitis.map((digit, i) => (
          <div className="grid-body" key={i}>
            {mapping[digit].map((item, index) => (
              <ClockHands position={item} key={index} />
            ))}
          </div>
        ))}
        <div className="colon">
          <div />
          <div />
        </div>
        {minDigits.map((digit, i) => (
          <div className="grid-body" key={i}>
            {mapping[digit].map((item, index) => (
              <ClockHands position={item} key={index} />
            ))}
          </div>
        ))}
        <div className="colon">
          <div />
          <div />
        </div>
        {secondDigits.map((digit, i) => (
          <div className="grid-body" key={i}>
            {mapping[digit].map((item, index) => (
              <ClockHands position={item} key={index} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
